module.exports = __webpack_public_path__ + "55188eb6eb0293879f3784049efc64e5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/window-sunset-beach.png
// module id = 1651
// module chunks = 0